(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDialogController', PhoneCallResultGroupDialogController);

    PhoneCallResultGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PhoneCallResultGroup', 'PhoneCallResult'];

    function PhoneCallResultGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PhoneCallResultGroup, PhoneCallResult) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.clear = clear;
        vm.save = save;
        vm.phonecallresults = PhoneCallResult.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.phoneCallResultGroup.id !== null) {
                PhoneCallResultGroup.update(vm.phoneCallResultGroup, onSaveSuccess, onSaveError);
            } else {
                PhoneCallResultGroup.save(vm.phoneCallResultGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:phoneCallResultGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
